// libs
import React, { useState, useEffect, useContext } from "react";
import { faCalendarTimes, faCalendarAlt } from "@fortawesome/free-regular-svg-icons";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import base64 from "base-64";
import Cookies from "universal-cookie";
import TagManager from 'react-gtm-module';

// utils
import Paginacao from "../../../../../../../../../../../util/paginacao/.mixins/paginacao";
import CardPedido from "../../../../../../../../../../../util/cardPedido/.mixins";
import ListaVazia from "../../../../../../../../../../../util/listaVazia/.mixins/ListaVazia";
import { AuthContext } from "../../../../../../../../../../../../contexts/AuthContext";

// childrens
import Download from "../../../../../../../../protocolo/childrens/content/childrens/download/.mixins/index";

// controllers
import Protocolos_controller from "../../../../../../../../../../../../controllers/protocolo";
import Config from "../../../../../../../../../../../../controllers/config";
import Log from "../../../../../../../../../../../../controllers/log";
import OpcoesRecebimento_controller from "../../../../../../../../../../../../controllers/opcoesRecebimento";

export default ({ props, dtInitial, dtEnd, ChangeModalDetailState }) => {
    const { user } = useContext(AuthContext);
    
    const { fornecedor,firstLoad } = props.state;
    const [dadosProtocoloAgendamento, setDadosProtocoloAgendamento] = useState([]);
    const [isPDFOpen, setIsPDFOpen] = useState(false);
    const [dataAgendaPDFModal, setDataAgendaPDFModal] = useState("");
    const diasPermitidoAnteciparPagamento = 1;
    function checkPermissionOpcaoPagamento(date, Permission) {
        const diffDays = date.diff(moment().toDate(), "days");
        const diasAnteciparPagamento = diffDays - diasPermitidoAnteciparPagamento;
        if (Permission > 0 &&
            diffDays >= diasPermitidoAnteciparPagamento &&
            user.permissions["opcoes-de-recebimento"]) {
            return {
                tooltip: `Permitido alterar opção de pagamento em até ${diasPermitidoAnteciparPagamento} dias antes da entrega, 
                ${
                    diasAnteciparPagamento == 0
                        ? "último dia"
                        : `você ainda tem ${diasAnteciparPagamento} 
                        ${diasAnteciparPagamento > 1 ? "dias" : "dia"}`
                } para alterar as opções de Pagamento deste pedido.`,
                status: false,
            };
        } else {
            return {
                tooltip:
                    Permission == 0 || !user.permissions["opcoes-de-recebimento"]
                        ? "Você não tem condições de pagamento liberadas. Se necessário entre em contato com equipe Tok&Stok"
                        : `Pedidos com data de agendamento em até ${diasPermitidoAnteciparPagamento} dia antes da entrega não podem ser antecipados`,
                status: true,
            };
        }
    }

    function stringToDateFormater(dateStr) {
        const date = dateStr.split(" ");
        const dateObject = moment(date[0], "DD/MM/YYYY");
        return dateObject;
    }

    function dateToStringFormater(date) {
        return `${date.getUTCDate()}/${date.getUTCMonth() + 1}/${date.getUTCFullYear()}`;
    }

    function handleClickPDF() {
        setIsPDFOpen(!isPDFOpen);
    }

    const loadData = async () => {
        // Retira histórico rowsperpage
        await props.setState({
            isLoading: true,
            rowsPerPagePedidoProtocolo: 5,
            firstLoad: true,
        });
        loadProtocoloAgendamento({
            linha_inicial: 0,
            qtd_registro: props.state.rowsPerPagePedidoProtocolo,
        });
        await props.setState({
            isLoading: false,
            firstLoad: false,
        });
    };
    
    useEffect(() => {
        loadData();
    }, [fornecedor, dtInitial, dtEnd]);

    async function loadDescontos() {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            //define filtros
            const filters = {
                idFornecedor: fornecedor,
            };
            if (filters.idFornecedor && user.permissions["opcoes-de-recebimento"]) {
                const r_descontos = await OpcoesRecebimento_controller.getDescontos(token, filters);
                let j_r_descontos = JSON.parse(r_descontos.body);

                if (j_r_descontos.length === 1 && j_r_descontos[0].IN_COND_PADRAO_FORNEC === "S") {
                    j_r_descontos = [];
                }

                if (r_descontos.res.statusCode === 200) {
                    return j_r_descontos.length;
                } else {
                    if (
                        j_r_descontos.status === false &&
                        j_r_descontos.message &&
                        j_r_descontos.message.includes("Token inválido!")
                    ) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    } else if (
                        j_r_descontos.status === false &&
                        j_r_descontos.message &&
                        (j_r_descontos.message.includes("Campos necessários") ||
                            j_r_descontos.message.includes("Permissão"))
                    ) {
                        throw new Error(j_r_descontos.message);
                    } else {
                        throw new Error("O ocorreu um erro no sistema!");
                    }
                }

                //auditoria
                const str = `Efetuada requisição para recuperação de dados de descontos! 
                Response:( Method: ${r_descontos.res.request.method}, 
                StatusCode: ${r_descontos.res.statusCode}, 
                Body: (limited 100chars)${r_descontos.body.substr(0, 100)} )`;
                Log.info(token, str);
            }
        } catch (error) {
            //auditoria
            const str = `Erro na recuperação de dados de descontos! 
                Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token, str);
        }
    }

    //Paginação - Functions
    const onChangePage = (pageFrom) => {
        loadProtocoloAgendamento({
            linha_inicial: pageFrom,
            qtd_registro: props.state.rowsPerPagePedidoProtocolo,
        });
    };
    const setRowsPerPage = (value) => {
        props.setState({ rowsPerPagePedidoProtocolo: value });
        loadProtocoloAgendamento({
            linha_inicial: 0,
            qtd_registro: value,
        });
    };

    async function loadProtocoloAgendamento({linha_inicial,qtd_registro}) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        const havePermissionDesconto = await loadDescontos();
        try {
            props.setState({ isLoading: true });
            const filters = {
                idFornecedor: fornecedor,
                dtInicio: dateToStringFormater(dtInitial),
                dtFim: dateToStringFormater(dtEnd),
                paginaDe: linha_inicial,
                paginaAte: qtd_registro,
            };
            const r_protocolo = await Protocolos_controller.getGerenciaPedidosProtocoloDatas(
                token,
                filters
            );
            const j_r_protocolo = JSON.parse(r_protocolo.body);
            if (r_protocolo.res.statusCode === 200) {
                const arrayItens = j_r_protocolo.itens.map((e) => {
                    const cardPermission = checkPermissionOpcaoPagamento(
                        stringToDateFormater(e.DT_AGENDA),
                        havePermissionDesconto
                    );
                    return {
                        ...e,
                        QT_TOTAL_REGS: e.QT_TOTAL_REGS,
                        ds_opcao_pag: `${e.DS_PAGTO} dias`,
                        dt_agendamento: stringToDateFormater(e.DT_AGENDA),
                        ds_filial: `${e.CD_FIL} - ${e.NM_FIL}`,
                        ds_situacao: e.SIT,
                        bt_component: [
                            {
                                label: "VER DETALHE DA ENTREGA",
                                variant: "contained",
                                handler: () => {
                                    const dataAgenda = e.DT_AGENDA.split(" ");
                                    const params = {
                                        idFornecedor: fornecedor,
                                        dataAgenda: dataAgenda[0],
                                        codPagto: e.CD_PAGTO,
                                        codFilial: e.CD_FIL,
                                    };
                                    const infoParam = {
                                        dt_agendamento: stringToDateFormater(dataAgenda[0]),
                                        ds_opcao_pag: `${e.DS_PAGTO} dias`,
                                    };
                                    props.setState({
                                        infoPedidoProtocolo: infoParam,
                                    });
                                    loadProtocoloList(params);
                                    loadProtocoloNF(params);
                                    ChangeModalDetailState();

                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'event',
                                            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                                            eventAction: 'clique:botao',
                                            eventLabel: 'ver-detalhe-na-entrega',
                                        }
                                    });
                                },
                            },
                            {
                                label: "ALTERAR OPÇÃO DE PAGAMENTO",
                                variant: "contained",
                                tooltip: cardPermission.tooltip,
                                disabled: cardPermission.status,
                                startIcon: cardPermission.status ? faCalendarTimes : faCalendarAlt,
                                handler: () => {
                                    const cookies = new Cookies();
                                    const dataAgenda = e.DT_AGENDA.split(" ");
                                    const params = {
                                        idFornecedor: fornecedor,
                                        dataAgenda: dataAgenda[0],
                                        codPagto: e.CD_PAGTO,
                                        codFilial: e.CD_FIL,
                                        dataAgendamento: stringToDateFormater(dataAgenda[0]),
                                        opcaoPagDias: e.DS_PAGTO,
                                    };

                                    cookies.set(
                                        "OpcaoPagamentoData",
                                        base64.encode(JSON.stringify(params)),
                                        { path: "/" }
                                    );

                                    props.props.router.push(
                                        `/gerenciarPedidos/protocoloagendamento/opcaorecebimento`
                                    );

                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'event',
                                            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                                            eventAction: 'clique:botao',
                                            eventLabel: 'alterar-opcao-pagamento',
                                        }
                                    });
                                },
                            },
                            {
                                label: "IMPRIMIR PROTOCOLO",
                                variant: "outlined",
                                startIcon: faPrint,
                                handler: async () => {
                                    const [dataAgenda] = e.DT_AGENDA.split(" ");
                                    const params = {
                                        idFornecedor: fornecedor,
                                        dataAgenda,
                                        codPagto: e.CD_PAGTO,
                                        codFilial: e.CD_FIL,
                                    };
                                    const [dataAgendaPDFModal] = e.DT_AGENDA.split(" ");

                                    setDataAgendaPDFModal(dataAgendaPDFModal);
                                    await loadProtocoloList(params);

                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'event',
                                            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                                            eventAction: 'clique:botao',
                                            eventLabel: 'imprimir-protocolo',
                                        }
                                    });

                                    return handleClickPDF();
                                },
                            },
                        ],
                    };
                });

                setDadosProtocoloAgendamento(arrayItens);
                props.setState({
                    totalRowsPedidoProtocolo: arrayItens.length > 0 ? arrayItens[0].QT_TOTAL_REGS : 0,    
                    isLoading: false,
                });
            } else {
                if (
                    j_r_protocolo.status == false &&
                    j_r_protocolo.message &&
                    j_r_protocolo.message.includes("Token inválido!")
                ) {
                    this.childAlerta.current.retorno("Autentificação inválida!", "error");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });
            props.childAlerta.current.retorno(error.message, "error");
        }
    }

    async function loadProtocoloList(filters) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            props.setState({ isLoading: true });

            const r_protocolo = await Protocolos_controller.getGerenciaPedidosProtocolo(
                token,
                filters
            );
            const j_r_protocolo = JSON.parse(r_protocolo.body);
            if (r_protocolo.res.statusCode === 200) {
                const arrayItens = j_r_protocolo.itens.map((e) => {
                    return {
                        ...e,
                        ds_opcao_pag: `${e.DS_PAGTO} dias`,
                    };
                });

                await props.setState({
                    detalhePedidoProtocolo: arrayItens,
                    isLoading: false,
                });
            } else {
                if (
                    j_r_protocolo.status == false &&
                    j_r_protocolo.message &&
                    j_r_protocolo.message.includes("Token inválido!")
                ) {
                    this.childAlerta.current.retorno("Autentificação inválida!", "error");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });
            props.childAlerta.current.retorno(error.message, "error");
        }
    }

    async function loadProtocoloNF(filters) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            props.setState({ isLoading: true });

            const r_protocolo = await Protocolos_controller.getGerenciaPedidosProtocoloNF(
                token,
                filters
            );
            const j_r_protocolo = JSON.parse(r_protocolo.body);
            if (r_protocolo.res.statusCode === 200) {
                const arrayItens = j_r_protocolo.itens.map((e) => {
                    return {
                        ...e,
                    };
                });
                await props.setState({
                    detalhePedidoProtocoloNF: arrayItens,
                    isLoading: false,
                });

                ChangeModalDetailState();
            } else {
                if (
                    j_r_protocolo.status == false &&
                    j_r_protocolo.message &&
                    j_r_protocolo.message.includes("Token inválido!")
                ) {
                    this.childAlerta.current.retorno("Autentificação inválida!", "error");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") {
                errorString = error.message;
            }
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });
            props.childAlerta.current.retorno(error.message, "error");
        }
    }

    return (
        <div style={{ maxHeight: "60vh", height: "100%", overflow: "auto" }}>
            {!props.state.isLoading && dadosProtocoloAgendamento.length <= 0 && (
                <div style={{ padding: "7px 30px 7px 30px" }}>
                    <ListaVazia
                        tipoMensagem={"Search"}
                        text={"Busque por outro intervalo de Datas"}
                        textDescription={`Não encontramos nenhum protocolo de agendamento entre 
                                    ${dateToStringFormater(dtInitial)} e 
                                    ${dateToStringFormater(dtEnd)}.`}
                    />
                </div>
            )}
            {dadosProtocoloAgendamento.map((e, i) => {
                return (
                    <div key={i} style={{ padding: "7px 30px 7px 30px" }}>
                        <CardPedido {...e} />
                    </div>
                );
            })}
            <Paginacao
                rowsPerPage={props.state.rowsPerPagePedidoProtocolo}
                totalRows={props.state.totalRowsPedidoProtocolo}
                rowsPerPageOptions={props.state.rowsPerPageOptionsPedidoProtocolo}
                onChangePage={onChangePage}
                firstLoad={firstLoad}
                setRowsPerPage={setRowsPerPage}
            />

            <Download
                handleClosePDF={handleClickPDF}
                state={{
                    dataAgenda: dataAgendaPDFModal,
                    modalPDFUserData: `Fornecedor: ${fornecedor}`,
                    modalPDF: isPDFOpen,
                    itensTable: props.state.detalhePedidoProtocolo,
                }}
            />
        </div>
    );
};
